import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingFlag: 0,
  locationLists: [],
  teamsFormInputValues: {
    locationName: "",
    teamName: "",
    isActive: false,
    level: '',
    departmentList: '',
  },
  validationErrors: {},
  errorMessage: null,
  successMessage: null,
  data: [],
  level: [],
};

export const teamsSlice = createSlice({
  name: "teams",
  initialState,
  reducers: {
    setSampleData: (state, action) => {
      state.data = action.payload;
    },
    // Form data handle
    updateFileld: (state, action) => {
      const { field, value } = action.payload;
      state.teamsFormInputValues[field] = value;
    },
    // Common Success message
    setSuccessMessage: (state, action) => {
      state.successMessage = action.payload;
    },
    // Commom Error Message
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    // Loading flag increment
    setLoadingFlagIncrement: (state) => {
      state.loadingFlag = state.loadingFlag + 1;
    },
    // Loading flag decrement
    setLoadingFlagDecrement: (state) => {
      if (state.loadingFlag !== 0) {
        state.loadingFlag = state.loadingFlag - 1;
      }
    },
    formReset: (state) => {
      state.teamsFormInputValues = {
        locationName: "",
        teamName: "",
        isActive: false,
        level: '',
        departmentList: '',
      };
    },
    setEditDetailsForm: (state, action) => {
      const { locationName, teamName, isActive, level, departmentList } = action.payload;
      state.teamsFormInputValues.locationName = locationName;
      state.teamsFormInputValues.teamName = teamName;
      state.teamsFormInputValues.isActive = isActive;
      state.teamsFormInputValues.level = level;
      state.teamsFormInputValues.departmentList = departmentList
    },
    // setEditMultiSelectForm: (state, action) => {
    //   const { filterDepartment } = action.payload;
    //   // state.teamsFormInputValues.level = filterLevel;
    //   state.teamsFormInputValues.departmentList = filterDepartment;
    // },
    setClearData: (state) => {
      state.data = [];
    },
    setLevel: (state, action) => {
      state.level = action.payload;
    },
  },
});

export const {
  setLoadingFlagIncrement,
  setLoadingFlagDecrement,
  setLocationListsDropdown,
  updateFileld,
  setSuccessMessage,
  setErrorMessage,
  setSampleData,
  formReset,
  setEditDetailsForm,
  setClearData,
  setLevel,
  setEditMultiSelectForm,
} = teamsSlice.actions;

export default teamsSlice.reducer;
